import {computed, inject, Injectable, Signal} from '@angular/core';

import {DimensionLevel, Perspective} from '@selpia/shared/models';

import {PerspectiveStore} from '../state/perspective.store';

@Injectable({
  providedIn: 'root',
})
export class PerspectiveFacade {
  readonly #store: PerspectiveStore = inject(PerspectiveStore);

  readonly perspective: Signal<Perspective | undefined> = this.#store.perspective;
  readonly focusDimensionLevelName = computed(() => this.perspective()?.focusDimensionLevel.name);

  readonly date: Signal<Date | undefined> = computed(() => this.perspective()?.date);

  readonly focusDimensionLevel: Signal<DimensionLevel | undefined> = this.#store.focusDimensionLevel;
}
